import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { FirebaseContext } from '../../firebase/FirebaseContext';
import { Nav } from '../Nav';
import { Copyright } from './Copyright';

const theme = createTheme();

export const SignIn = () => {
  const navigate = useNavigate();
  const { auth } = useContext(FirebaseContext);

  const handleSignIn = useCallback(
    async (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      try {
        const data = new FormData(e.currentTarget);
        const email = data.get('email');
        const password = data.get('password');
        if (
          !email ||
          !password ||
          typeof email !== 'string' ||
          typeof password !== 'string'
        ) {
          return;
        }

        const credentials = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );

        navigate(`/dashboard`);
      } catch (e) {
        // TODO: error handling
        console.log(e);
      }
    },
    [auth]
  );

  return (
    <ThemeProvider theme={theme}>
      <Nav>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingTop: '10em',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              onSubmit={handleSignIn}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      </Nav>
    </ThemeProvider>
  );
};
